import {inject, Injectable} from "@angular/core";
import {take} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {removeIfNullUndefined} from "@shared/commons/transform.commons";

export enum ExecutionStatus {
    PROCESSING = 'PROCESSING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    UNAVAILABLE = 'UNAVAILABLE'
}

@Injectable({
    providedIn: 'root'
})
export class IntegrationsApiService {
    private readonly apiServiceUrl = environment.serviceApi;
    private http = inject(HttpClient);

    getPgfnExecutionHistory(params?: any) {
        params = removeIfNullUndefined(params);
        return this.http.get(`${this.apiServiceUrl}/v1/integrations/pgfn/execution-history`, {params})
            .pipe(take(1));
    }

    getPgfnExecutionStatus() {
        return this.http.get(`${this.apiServiceUrl}/v1/integrations/pgfn/execution-status`)
            .pipe(take(1));
    }

    startPgfnSync(params?: { lastYears?: number; year?: number }) {
        params = removeIfNullUndefined(params);
        return this.http.get(`${this.apiServiceUrl}/v1/integrations/pgfn/sync-all`, {params})
            .pipe(take(1));
    }
}
